/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Speed limit input bounds in km/h (matching backend ValidationConstants).
 * The frontend converts these to the user's display unit for validation and display.
 */
export const SPEED_LIMIT_BOUNDS_KMH = {
  min: 5,
  max: 9999
} as const;
